<template>
  <div class="speakers-container" @click="showDialog" @mouseleave="hideDialog">
    <div class="top-item-left">
      <img class="dubber-image" :src="speakerInfo.image" alt="">
      <div>
        <div class="dubber-name">{{speakerInfo.name}}</div>
        <div class="dubber-desc">{{speakerInfo.des}}</div>
      </div>
    </div>
    <Speakers v-show="visible" @selectedSpeaker="selectedSpeaker" :visible="visible"></Speakers>
  </div>
</template>

<script>
import { getSpeakersMap } from 'utils/model.js'
import Speakers from 'components/speakers.vue'
export default {
  name: 'speakers-container',
  data() {
    return {
      visible: false,
      speakerInfo: {}
    }
  },
  components: {
    Speakers
  },
  computed: {
    dubbingParams () {
      return this.$store.state.global.dubbingParams
    }
  },
  watch: {
    dubbingParams (val) {
      if (this.speakerMap) {
        this.speakerInfo = this.speakerMap[val.speaker_id]
      }
    },
  },
  mounted() {
    this.getSpeakersMap()
  },
  methods: {
    async getSpeakersMap () {
      this.speakerMap = await getSpeakersMap()
      this.speakerInfo = this.speakerMap[this.dubbingParams.speaker_id]
    },
    showDialog() {
      this.visible = true
      this.$emit('showDialog')
    },
    hideDialog () {
      this.visible = false
    },
    selectedSpeaker (item) {
      this.speakerInfo = this.speakerMap[item.id]
      let dubbingParams = {...this.dubbingParams}
      dubbingParams.speaker_id = item.id
      this.$store.dispatch('global/setDubbingParams', dubbingParams)
      this.hideDialog()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.speakers-container {
  height: 70px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  padding: 0 14px;
  cursor: pointer;
  .top-item-left {
    display: flex;
    align-items: center;
    .dubber-image {
      width: 50px;
      height: 50px;
      margin-right: 5px;
      border-radius: 25px;
    }
    .dubber-desc {
      color: #999999;
      margin-top: 5px;
    }
  }
}
</style>
